import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import EquipmentListAccordion from "../../common/components/LocationSelectionStep/EquipmentListAccordion";
import {
  assetGroupActivated,
  assetGroupDeactivated,
  setKeyHandoverSelectedService,
  setSelectedGroup,
} from "../../../../redux/slice/bookingCreation/bookingCreationSlice";
import LoaderOverlay from "../../../layout/components/LoaderOverlay";
import _ from "lodash";
import { KeyHandoverServiceType } from "../../../../types/baseTypes";

function EquipmentSelectionStep() {
  const dispatch = useDispatch();
  const selectedLocation = useSelector(
    (state: RootState) => state.bookingCreation.selectedLocation
  );
  // const { data: equipments } = useGetLocationEquipmentQuery({ locationId: selectedLocation?.id });
  const equipments = useSelector((state: RootState) =>
    selectedLocation
      ? state.bookingCreation.groupsByLocation[selectedLocation.id]
      : undefined
  );
  const isLoading = _.isEmpty(equipments);

  const selectedEquipment = useSelector(
    (state: RootState) => state.bookingCreation.selectedGroup
  );

  const [expandedAccordion, setExpandedAccordion] = useState<string | null>(
    selectedEquipment ? selectedEquipment.id : null
  ); // Track the currently expanded accordion

  const handleAccordionChange = (equipment: any) => {
    const selectedService = equipment.priceCategoryInfo
      .name as KeyHandoverServiceType;

    setExpandedAccordion(
      expandedAccordion === equipment.id ? null : equipment.id
    ); // Toggle the expanded accordion
    if (expandedAccordion === equipment.id) {
      dispatch(assetGroupDeactivated());
    } else {
      dispatch(setKeyHandoverSelectedService(selectedService));
      dispatch(assetGroupActivated(equipment));
      dispatch(setSelectedGroup(equipment));
    }
  };

  return (
    <>
      <div
        className="flex flex-col gap-4"
        style={{
          maxHeight: "98%", // Set your desired max height
          overflowY: "auto", // Enable vertical scrolling
          marginLeft: "16px", // Add margin to the left
          marginRight: "16px", // Add margin to the right
        }}
      >
        {equipments?.map((item: any, index: number) =>
          item.priceCategoryInfo ? (
            <div
              key={index}
              className={`[&:not(:last-child)]:border-b-[1px] border-itemListBorder ${
                expandedAccordion && expandedAccordion !== item.id
                  ? "blur-[1px] opacity-50"
                  : "blur-0 opacity-100"
              }`}
            >
              <EquipmentListAccordion
                key={item.id}
                expanded={expandedAccordion === item.id} // Pass down the expanded state
                onAccordionChange={() => handleAccordionChange(item)} // Pass down the change handler
                equipment={item}
                priceCategoryInfo={item?.priceCategoryInfo}
                image={item?.featuredImage}
                name={item?.name}
                langNames={item?.langNames}
              />
            </div>
          ) : null
        )}
      </div>
      <LoaderOverlay open={isLoading} />
    </>
  );
}

export default EquipmentSelectionStep;
